import { ConfirmModal } from "features/common/components/ConfirmModal";
import { useImportModal } from "./useImportModal";
import { UploadButton } from "features/common/components/UploadButton";
import { FormInput } from "features/common/hook-form/FormInput";
import { Box, Divider } from "@mui/material";
import { AlertMessage } from "features/common/components/AlertMessage";

export interface ImportModalProps {
  title: string;
  open: boolean;
  onClose: () => void;
  type: "MASTER" | "PORTFOLIO";
}

export const ImportModal = ({
  title,
  open,
  onClose,
  type,
}: ImportModalProps) => {
  const {
    handleClose,
    importIsAllowed,
    control,
    onSubmit,
    handleFileChange,
    isSubmitting,
    importError,
    alertMessage,
    renderImportMessage,
    showImportMessage,
    importMessageSeverity,
    onAlertRemove,
  } = useImportModal({
    type,
    onClose,
  });

  return (
    <ConfirmModal
      title={title}
      open={open}
      onClose={handleClose}
      disableBackdropClick
      isLoading={isSubmitting}
      error={""}
      secondaryAction={<></>}
      formId="upload-form"
      disableConfirmButton={!importIsAllowed}
      children={
        <Box>
          <form
            id="upload-form"
            style={{
              display: "flex",
              marginTop: "10px",
            }}
            onSubmit={onSubmit}
          >
            <UploadButton
              sx={{ width: "110px", height: "40px" }}
              children="Choose file"
              onChange={handleFileChange}
            />
            <Divider sx={{ marginRight: "8px" }} />
            <FormInput
              name="filename"
              sx={{ minWidth: "346px" }}
              size="small"
              control={control}
              rules={{ required: "Please select a file" }}
              disabled
              aria-disabled
            />
          </form>

          {renderImportMessage && (
            <AlertMessage
              isPermanent={!!importError}
              show={showImportMessage}
              severity={importMessageSeverity}
              message={alertMessage}
              onClose={onAlertRemove}
            />
          )}
        </Box>
      }
    />
  );
};
